export const ROUTE_NAMES = {
    MAIN: '/',
    GUIDES: 'guides',
    PREMIUM: 'premium',
    GLOBAL_MARKETS: 'global',
    CRYPTO_MARKETS: 'crypto',
    ACCOUNT: 'account',
    TERMS: 'terms',
    TRADING: 'trading',
    BINANCE: 'binance',
    RITHMIC: 'rithmic',
    TT: 'tt',
    CQG: 'cqg',
    BYBIT: 'bybit',
    BITGET: 'bitget',
    OKX: 'okx',
    STAKING: 'staking',
    REFERRAL: 'referral',
    PARTNER: 'partner',
    PARTNER_REQUESTS: 'partner-requests',
    SYMBOL_PROPOSALS: 'symbol-proposals',
    PARTNER_CLIENTS: 'partner-clients',
    TRADE: 'trade',
    ACCOUNTS: 'accounts',
    SYMBOLS: 'symbols',
    ARCHITECTURE: 'architecture',
    BOOK: 'book',
    // Публичный отчёт по всем сделкам алгоритма (замена Google-таблицы).
    REPORT: 'report',
    // Страница всех отзывов пользователей.
    COMMENTS: 'comments',
}

export const NAV_LINK_NAMES = {
    MAIN: ROUTE_NAMES.MAIN,
    GLOBAL_MARKETS: `/${ROUTE_NAMES.GLOBAL_MARKETS}`,
    CRYPTO_MARKETS: `/${ROUTE_NAMES.CRYPTO_MARKETS}`,
    PREMIUM: `/${ROUTE_NAMES.PREMIUM}`,
    GUIDES: `/${ROUTE_NAMES.GUIDES}`,
    TERMS: `/${ROUTE_NAMES.TERMS}`,
    ACCOUNT: `/${ROUTE_NAMES.ACCOUNT}`,
    TRADING_BINANCE: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.BINANCE}`,
    TRADING_RITHMIC: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.RITHMIC}`,
    TRADING_BYBIT: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.BYBIT}`,
    BINANCE_TRADE: `/${ROUTE_NAMES.BINANCE}/${ROUTE_NAMES.TRADE}`,
    BINANCE_ACCOUNTS: `/${ROUTE_NAMES.BINANCE}/${ROUTE_NAMES.ACCOUNTS}`,
    BINANCE_SYMBOLS: `/${ROUTE_NAMES.BINANCE}/${ROUTE_NAMES.SYMBOLS}`,
    RITHMIC_TRADE: `/${ROUTE_NAMES.RITHMIC}/${ROUTE_NAMES.TRADE}`,
    RITHMIC_ACCOUNTS: `/${ROUTE_NAMES.RITHMIC}/${ROUTE_NAMES.ACCOUNTS}`,
    RITHMIC_SYMBOLS: `/${ROUTE_NAMES.RITHMIC}/${ROUTE_NAMES.SYMBOLS}`,
    TRADING_TT: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.TT}`,
    TT_TRADE: `/${ROUTE_NAMES.TT}/${ROUTE_NAMES.TRADE}`,
    TT_ACCOUNTS: `/${ROUTE_NAMES.TT}/${ROUTE_NAMES.ACCOUNTS}`,
    TT_SYMBOLS: `/${ROUTE_NAMES.TT}/${ROUTE_NAMES.SYMBOLS}`,
    TRADING_CQG: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.CQG}`,
    CQG_TRADE: `/${ROUTE_NAMES.CQG}/${ROUTE_NAMES.TRADE}`,
    CQG_ACCOUNTS: `/${ROUTE_NAMES.CQG}/${ROUTE_NAMES.ACCOUNTS}`,
    CQG_SYMBOLS: `/${ROUTE_NAMES.CQG}/${ROUTE_NAMES.SYMBOLS}`,
    BYBIT_TRADE: `/${ROUTE_NAMES.BYBIT}/${ROUTE_NAMES.TRADE}`,
    BYBIT_ACCOUNTS: `/${ROUTE_NAMES.BYBIT}/${ROUTE_NAMES.ACCOUNTS}`,
    BYBIT_SYMBOLS: `/${ROUTE_NAMES.BYBIT}/${ROUTE_NAMES.SYMBOLS}`,
    TRADING_BITGET: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.BITGET}`,
    BITGET_TRADE: `/${ROUTE_NAMES.BITGET}/${ROUTE_NAMES.TRADE}`,
    BITGET_ACCOUNTS: `/${ROUTE_NAMES.BITGET}/${ROUTE_NAMES.ACCOUNTS}`,
    BITGET_SYMBOLS: `/${ROUTE_NAMES.BITGET}/${ROUTE_NAMES.SYMBOLS}`,
    TRADING_OKX: `/${ROUTE_NAMES.TRADING}/${ROUTE_NAMES.OKX}`,
    OKX_TRADE: `/${ROUTE_NAMES.OKX}/${ROUTE_NAMES.TRADE}`,
    OKX_ACCOUNTS: `/${ROUTE_NAMES.OKX}/${ROUTE_NAMES.ACCOUNTS}`,
    OKX_SYMBOLS: `/${ROUTE_NAMES.OKX}/${ROUTE_NAMES.SYMBOLS}`,
    STAKING: `/${ROUTE_NAMES.STAKING}`,
    REFERRAL: `/${ROUTE_NAMES.REFERRAL}`,
    PARTNER: `/${ROUTE_NAMES.PARTNER}`,
    PARTNER_REQUESTS: `/${ROUTE_NAMES.PARTNER_REQUESTS}`,
    SYMBOL_PROPOSALS: `/${ROUTE_NAMES.SYMBOL_PROPOSALS}`,
    ARCHITECTURE: `/${ROUTE_NAMES.ARCHITECTURE}`,
    BOOK: `/${ROUTE_NAMES.BOOK}`,
    REPORT: `/${ROUTE_NAMES.REPORT}`,
    COMMENTS: `/${ROUTE_NAMES.COMMENTS}`,
    // Партнёрская «админка»: клиенты по каждой бирже (read-only).
    PARTNER_CLIENTS_BINANCE: `/${ROUTE_NAMES.PARTNER_CLIENTS}/${ROUTE_NAMES.BINANCE}`,
    PARTNER_CLIENTS_BYBIT: `/${ROUTE_NAMES.PARTNER_CLIENTS}/${ROUTE_NAMES.BYBIT}`,
    PARTNER_CLIENTS_OKX: `/${ROUTE_NAMES.PARTNER_CLIENTS}/${ROUTE_NAMES.OKX}`,
    PARTNER_CLIENTS_RITHMIC: `/${ROUTE_NAMES.PARTNER_CLIENTS}/${ROUTE_NAMES.RITHMIC}`,
}

export const ROUTES_WITHOUT_PERMISSIONS = [
    NAV_LINK_NAMES.MAIN,
    NAV_LINK_NAMES.TERMS,
    NAV_LINK_NAMES.ACCOUNT,
    NAV_LINK_NAMES.GUIDES,
    NAV_LINK_NAMES.GLOBAL_MARKETS,
    NAV_LINK_NAMES.CRYPTO_MARKETS,
    NAV_LINK_NAMES.PREMIUM,
    // Доступны гостям в режиме предпросмотра (формы видно, активация после
    // регистрации) — 401 на них не должен выкидывать на главную.
    NAV_LINK_NAMES.STAKING,
    NAV_LINK_NAMES.REFERRAL,
    NAV_LINK_NAMES.PARTNER,
    // Публичный отчёт — витрина результатов, открыт всем без авторизации.
    NAV_LINK_NAMES.REPORT,
    // Отзывы читают все; писать может только вошедший.
    NAV_LINK_NAMES.COMMENTS,
]
